export const locale = {
  lang: 'en',
  data: {
    'NAV': {
      'MENU': {
        'TITLE'        : 'MENU',
        'PROJECTS'      : {
          'TITLE': 'Projects'
        },
        'REPORTS'      : {
          'TITLE': 'Reports'
        },
        'FOOTPRINT'     : {
          'TITLE'       : 'Footprint',
          'ENTITYCHART' : {
            'TITLE': 'Entity Chart'
          },
          'TRANSACTIONS': {
            'TITLE': 'Transactions'
          },
          'STREAMS': {
            'TITLE': 'Streams'
          }
        },
        'NOTIFICATIONS': {
          'TITLE': 'Notifications'
        },
        'CONTACTS'     : {
          'TITLE': 'Contacts'
        },
        'FORM_EDITOR'     : {
          'TITLE': 'Form Editor'
        },
        'SMART_GRID'     : {
          'TITLE': 'Smart Grid'
        },
        'TRANSFER_BOX'     : {
          'TITLE': 'Transfer Box'
        },
        'FILE_MANAGER'     : {
          'TITLE': 'File Manager'
        },
        'FLAT_SELECTOR'     : {
          'TITLE': 'File Manager'
        },
        'KANBAN_BOARD'     : {
          'TITLE': 'Kanban Board'
        },
        'TASK_MANAGER'     : {
          'TITLE': 'Task Manager'
        },
      },

      'ADMIN': {
        'TITLE'       : 'ADMIN',
        'HELP'        : {
          'TITLE': 'Help'
        },
        'RELEASENOTES': {
          'TITLE': 'Release Notes'
        },
        'PRIVACY'     : {
          'TITLE': 'Privacy'
        }
      }
    }
  }
};
